export const initialState = {
    name: '',
    pattern: '',
};

export const voicePoliciesPath = '/voice-policies';

export const breadCrumbTrail = [
    { label: 'Admin', path: '' },
    { label: 'Voice Policies', path: voicePoliciesPath },
    { label: 'Add Voice Policy', path: '' },
];

export const breadCrumbTrailEdit = [
    { label: 'Admin', path: '' },
    { label: 'Voice Policies', path: voicePoliciesPath },
    { label: 'Edit Voice Policy', path: '' },
];

export const addHeader = 'Voice Policy Details';
export const editHeader = 'Edit Voice Policy Details';

// Preserved from the retired MUI page (src/pages/telephony/voicePolicies/walkthroughIds.js)
// so existing walkthroughs keep resolving to the same target ids.
export const walkthroughIds = {
    ufVoicePolicy: '/voice-policies/input/voicePolicy',
    ufPattern: '/voice-policies/input/pattern',
};
